import { Box, Icon, Text } from "@chakra-ui/react";
import { IoWarning } from "react-icons/io5";

/**
 * RevisionChip — the supplementary amber "needs revision" chip that sits BESIDE
 * the status pill (never replacing it), styled to match ReviewStatusPill (22px,
 * radius component.sm, xs/500, filled warning glyph). Ports design.tsx
 * `RevisionChip` (~lines 240–247).
 *
 * Pass `count` for the campaign card / drawer header ("N need revision"); omit
 * it for a single resource row / the review-workspace header ("Revisions
 * required"). With a count of 0 it renders nothing.
 */
export interface RevisionChipProps {
  /** How many reviews/accounts need revision. Omit for the countless flag. */
  count?: number;
}

const RevisionChip = ({ count }: RevisionChipProps) => {
  if (count != null && count <= 0) return null;
  return (
    <Box
      as="span"
      display="inline-flex"
      alignItems="center"
      gap="2xs" // 4px
      h="22px"
      px="2xs"
      borderRadius="component.sm" // 4px
      bg="warning.50"
      color="warning.700"
      fontFamily="body"
      fontWeight={500}
      fontSize="xs" // 12px
      lineHeight="1"
      whiteSpace="nowrap"
      flexShrink={0}
      data-testid="campaign-revision-chip"
    >
      <Icon as={IoWarning} boxSize="12px" aria-hidden />
      <Text as="span">
        {count != null
          ? `${count} need${count === 1 ? "s" : ""} revision`
          : "Revisions required"}
      </Text>
    </Box>
  );
};

export default RevisionChip;
